module.exports = __webpack_public_path__ + "446d8f305ba8196538e98965445126ce.pdf";